import styles from "./explore_banner.module.scss";

export const ExploreBanner = ({ title, description }) => {
  return (
    <>
      {(title || description) && (
        <section className={styles.section_explore_banner}>
          <div className="container">
            <div className={styles.wrapper}>
              <div className={styles.text_wrapper}>
                {title && <h1>{title}</h1>}
                {description && <p>{description}</p>}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ExploreBanner;
